<template>
    <div id="audio-player">
        <div class="image-container">
            <div class="bg bg-blur" :style="{backgroundImage:'url('+data.bg+')'}"></div>
            <div class="content-front"><img :src="data.image"></div>
            <i class="playState icon_play" v-show="playState == 'paused'" @click="playAudio"></i>
            <i class="playState icon_pause" v-show="playState != 'paused'" @click="pauseAudio"></i>
            <div class="text" id="playtime">{{playTime}}</div>
            <!-- <div class="" id="title">{{title}}</div> -->
        </div>
        <!-- <div class="page-title">
            <h1>蒙古秘史</h1>
        </div> -->
        <div class="story-text" v-if="data.text">
          <img :src="data.text">
        </div>
        <audio ref="audio" id="audio" @timeupdate="updatePlaytime" @loadedmetadata="updatePlaytime">
            <source :src="data.audio" type="audio/mpeg">
        </audio>
    </div>
</template>

<script>
export default {
  // props: ['image', 'title', 'audio', 'text'],
  props: ['data'],
  methods: {
    updatePlaytime (res) {
      // console.log(res)
      // this.audio.maxTime = res.target.duration
      this.playTime = this.formatTime(res.target.currentTime) + ' / ' + this.formatTime(res.target.duration)
    },

    playAudio () {
      console.log('playAudio')
      this.playState = 'play'
      // this.updateButton();
      this.$refs.audio.play()
    },
    pauseAudio () {
      this.playState = 'paused'
      // updateButton();
      // audio.pause();
      this.$refs.audio.pause()
    },
    formatTime (seconds) {
      var min = parseInt(seconds / 60)
      var sec = parseInt(seconds % 60)
      if (min < 10) {
        min = '0' + min
      }
      if (sec < 10) {
        sec = '0' + sec
      }
      return min + ':' + sec
    }
  },
  data () {
    return {
      bgStyle: {
        backgroundImage: ''
      },
      playState: 'paused',
      playTime: '',
      duration: 0,
      currentTime: 0
    }
  }
}
</script>

<style scoped>
  .image-container {
    width: 100%;
    height: 320px;
    color: #ffffff;
    font-size: 40px;
    position: relative;
  }
  .image-container .bg {
    background: url('//naranzug.ip008.com/h5/mongol/images/01.png');
    height:320px;
    text-align: center;
    line-height: 320px;
  }
  .image-container .bg-blur {
    float: left;
    width: 100%;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    -webkit-filter: blur(25px);
    -moz-filter: blur(25px);
    -o-filter: blur(25px);
    -ms-filter: blur(25px);
    filter: blur(25px);
  }
  .image-container .content-front {
    position:absolute;
    top:50%;
    left:50%;
    /* margin-top:-210px;
    margin-left:-360px; */
    -webkit-transform: translate3d(-50%,-50%,0);
    transform: translate3d(-50%,-50%,0);

    height:160px;
    line-height: 160px;
    text-align: center;
    z-index: 5;
  }
  .image-container img {
    width: 290px;
    height: 160px;
  }
  .image-container .text {
    font-size: 18px;
    z-index: 100;
    width: 220px;
    color: white;
    position: absolute;
    bottom: 20px;
    height: 40px;
    left: 50%;
    -webkit-transform: translate3d(-50%,-50%,0);
    transform: translate3d(-50%,-50%,0);
  }
  .playState {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate3d(-50%,-50%,0);
    transform: translate3d(-50%,-50%,0);
    width: 48px;
    height: 48px;
    z-index: 10;
    opacity:0.5;
    filter:alpha(opacity=50);
  }
  .playState.icon_play {
    background: url(//naranzug.ip008.com/h5/mongol/images/icon_play.png) no-repeat;
    background-size: 100% 100%;
  }
  .playState.icon_pause {
    background: url(//naranzug.ip008.com/h5/mongol/images/icon_pause.png) no-repeat;
    background-size: 100% 100%;
  }

</style>



// WEBPACK FOOTER //
// src/components/templates/AudioPlayer.vue